import React from "react";

const ContractModal = ({ contract, onClose }) => {
    return (
        <div className="modal" style={{ display: "block" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={onClose}>
                            &times;
                        </button>
                    </div>
                    <div className="modal-body">
                        <iframe
                            src={`pdf/${contract}`}
                            width="100%"
                            height="500px"
                            style={{ border: "none" }}
                            title="Contract PDF"
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContractModal;
